import styled from 'styled-components';

export const FormLabel = styled.label`
    color: var(--default-sub-txt);
    font-size: 14px;
    font-weight: 700;
    margin-bottom: 4px;
    display: inline-block;
`;
